<template>
<div class="styled-radio styled-radio--ou-donation row">
  <div v-for="amount of amounts" :key="amount" class="radio-part" :data-amount="amount" :id="amount">
      <input :id="`amount${amount}`" type="radio" class="amount" @click="selectedAmount = amount" :checked="selectedAmount == amount">
      <FormLabel :for="`amount${amount}`" :data-amount="amount" :class="{'fave__amt__label': (form.dayOfMonth && amount === 36) || (!form.dayOfMonth && amount === 108)}">
        <img src="https://res.cloudinary.com/orthodox-union/image/upload/w_25/v1749469110/heart-icon_hcjyd8.png" alt="fave amt" class="fave_amt" v-if="(form.dayOfMonth && amount === 36) || (!form.dayOfMonth && amount === 108)"/>
		  <MoneyFormat class="label-amount" :value="amount" :currencyCode="form.currency || 'USD'" :hide-subunits="subunits" />
	  </FormLabel>
  </div>
  
  <div class="amount_other__wrapper" v-if="includeOther" :class="form.currency">
        <span>other:</span>
      <input id="amount_other_check" type="radio" class="amount" name="amount" value="Other">
      <input id="amount_other_field" type="number" min="1" name="amount_other" :placeholder="amountText" v-model="customAmount" />
  </div>

  </div>
</template>
<script lang="ts">
import {
  computed,
  defineComponent,
  type PropType,
  ref,
  watch,
} from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'
import MoneyFormat from '~/components/MoneyFormat.vue'
import { queryParams } from '~/shared/query-params'

export default defineComponent({  props: {
    subunits: {
      type: Boolean,
      default: true
    },
    includeOther: {
      type: Boolean,
      default: true
    },
    defaultCheckedAount:{
      type: String
    },
    amountText:{
      type: String,
      default: "Enter amount",
    }
  },
  setup(props) {
    const { setValue, form, settings } = usePaymentForm()

    const selectedAmount = ref()
    const customAmount = ref(form.value.amount)

    watch(selectedAmount, (selectedAmount) => {
      if (selectedAmount) {
        customAmount.value = null

        setValue('amount', '' + selectedAmount)
      }
    })

    watch(customAmount, (customAmount) => {
      if (customAmount) selectedAmount.value = null

      if (!selectedAmount.value) setValue('amount', customAmount || null)
    })

    const amounts = computed(() => {
      // Check if this is a monthly payment (indicated by dayOfMonth being set)
      const isMonthly = !!form.value.dayOfMonth
      
      if (isMonthly) {
        // Return monthly amounts
        return [18, 36, 54, 100]
      }
      
      const amounts = settings!.amounts!

      if (Array.isArray(amounts)) {
        return amounts
      }

      return amounts[form.value.currency || 'USD']
    })

    const params = queryParams()
    
    if (params.amount) {
      //@ts-ignore
      if (amounts.value.includes(+params.amount)) {
        selectedAmount.value = params.amount
      }
      else {
        customAmount.value = params.amount
      }
    }

    if (props.defaultCheckedAount) {
      //@ts-ignore
      if (amounts.value.includes(+props.defaultCheckedAount)) {
        selectedAmount.value = props.defaultCheckedAount
      }
      else {
        customAmount.value = props.defaultCheckedAount
      }
    }

    return {
      form,
      amounts,
      selectedAmount,
      customAmount,
    }
  },
})
</script>
<style scoped lang="scss">
.oudonate-other-amount .amount_other__wrapper,
.styled-radio--ou-donation  .amount_other__wrapper{
    position: relative;
    margin-bottom: 0px;
    background: rgba(255, 255, 255, 0.05);
    overflow: hidden;
    // border: 1px solid #ddd;
    border-radius: 6px;
    padding: 5px 16px;
    flex: 1;
    line-height: 1;
    display: flex;
    align-items: center;
    gap: 12px;

    span{
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      color: #96999C;
      vertical-align: middle;

    }
    @media (max-width: 1020px) {
      gap:2px;
      padding: 0px;
       
        span{
          display: none;
        }
        #amount_other_check{
          display: none;
        }
    }

        @media (max-width: 960px) {
        width: calc((100% - 44px) / 3);
        min-width: calc((100% - 44px) / 3);
        max-width: calc((100% - 44px) / 3);
        }
   
    input[type='number'] {
          background: rgba(255, 255, 255, 0.1);
    border: 1px solid #595C5F;
    border-radius: 6px;
    color: #96999C;
    height: 38px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    vertical-align: middle;
    padding: 9px 12px;
    width: 100%;

    &:focus {
    border-color: #15329d;
    box-shadow: none;
    color: #222;
    background: white;
    box-shadow: 0 0 3px rgba(56, 93, 163, 0.5);
    }
    //   border: none;
    //   margin-left: 20px;
    //   box-shadow: none;
    //   width: calc(100% + 20px);
    //   font-size: 12px;
    
    }
    &:after {
      display: none !important;
    }
  }
.styled-radio--ou-donation.styled-radio {
  margin: 0 0 5px 0px;
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
              @media only screen and (max-width: 720px) {
              gap: 8px;
              }
  .radio-part {
    padding: 0px 5px;
    line-height: 1;
    @media (max-width: 720px) {
        width: calc((100% - 44px) / 3);
        padding: 0px;
    }
    @media (min-width: 720px) {
      flex: 0 1 118px;
      padding-right: 0px;
      padding-left: 0;
      margin-bottom: 0px;

      &:nth-child(6n) {
        padding-right: 0;
      }
    }

  }
  input[type='radio'] {
    height: 0;
    top: 20px;
    position: relative;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
  label {
    border-radius: 8px;
    padding: 12px;
    background: #ffffff;
    font-weight: bold;
    color: rgb(87, 87, 87);
    width: 100%;
    text-align: center;
    
    cursor: pointer;
    margin-top: -15px;
    gap: 12px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    @media only screen and (max-width: 720px) {
        height: 36px;
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        gap: 8px;
        padding: 0px;
        line-height: 20px;
    }

    &.fave__amt__label{
        .money_format.label-amount {
            color: #F87507;
        }
    }
    .money_format.label-amount {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    color: #1E50B4;

        @media only screen and (max-width: 720px) {
        font-size: 14px;
        line-height: 20px;
    }

    &:hover{
            background: #EBEBEB;
    }
}
  }
  input[type='radio']:checked + label {
    background: #F87507;
    color: white;

    &.fave__amt__label{
        img{
            display: none;
        }
        .money_format.label-amount {
        color: white;
        }
    }
    .money_format.label-amount {
        color: white;
    }
  

  }
  label:hover {
    background: #e9f0f7;
  }
  .amount_other__wrapper {
    input[type='number'] {

    }
  }
}  

.donateion__list {
    max-width: 508px;
    margin: auto;
}

.most__impactful{
    position: absolute;
    top: 37%;
    right: 128px;
        @media only screen and (max-width: 720px) {
     display: none;
    }
}
.most__impactful--mobile{
      position: absolute;
    top: 27%;
    right: 0px;
        @media only screen and (min-width: 720px) {
     display: none;
    }
}
</style>